import React, {useState} from "react";
import { Modal } from "react-bulma-components";
import { Section } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import { Button } from "react-bulma-components";
import { Form } from "react-bulma-components";
import useInput from "../../hooks/useInput";
import TrackingOptionsPicker from "../Settings/TrackingCategory/TrackingOptionsPicker";
import NominalCodePicker from "../Settings/NominalCodes/NominalCodePicker";

export default function MultipleEditModalWorkshop({
  open,
  setOpen,
  selected,
  saveSelected,
  trackingOptions,
  trackingObjects,
  nominalCodes,
  codeObjects
}) {

  const [invoiceNumber, invoiceNumberInput, setInvoiceNumber] = useInput({
    type: "text",
    label: "Workshop Invoice Number"
  });

  const [invoiceDate, invoiceDateInput] = useInput({
    type: "date",
    label: "Invoice Date"
  });

  const [trackingOption, setTrackingOption] = useState();
  const [nominalCode, setNominalCode] = useState();

  const onTrackingOptionChange = e => {
    setTrackingOption(trackingObjects[e.target.value]);
  }

  const onNominalCodeChange = e => {
    setNominalCode(codeObjects[e.target.value]);
  }

  const onSave = () => {
    saveSelected(invoiceNumber, null, trackingOption, nominalCode, null, null, invoiceDate).then(onClose);
  };

  const onClose = () => {
    setOpen(false);
    setInvoiceNumber("");
    setTrackingOption(undefined);
    setNominalCode(undefined);
  };

  return (
    <Modal closeOnBlur show={open} onClose={onClose}>
      <Modal.Content className={"wider-modal"}>
        <Section style={{ backgroundColor: "white" }}>
          <Columns>
            {invoiceNumberInput}
            {invoiceDateInput}
            <Columns.Column>
              <TrackingOptionsPicker
                name={"supplier_tracking_option"}
                label={"Tracking Option"}
                value={trackingOption}
                options={trackingOptions}
                blank={true}
                className={"not-small"}
                inlineEdit={false}
                editable={true}
                onChange={onTrackingOptionChange}
              />
            </Columns.Column>
            <Columns.Column>
              <NominalCodePicker
                name={"supplier_nominal_code"}
                label={"Nominal Code"}
                value={nominalCode}
                options={nominalCodes}
                blank={true}
                small={false}
                inlineEdit={false}
                editable={true}
                onChange={onNominalCodeChange}
              />
            </Columns.Column>
          </Columns>
          <Form.Field>
            <p>You are editing {Object.keys(selected).length} work items</p>
          </Form.Field>
          <Button color="success" onClick={onSave}>
            Save
          </Button>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
